<template>
  <div class="select-intent-tag">
    <p class="headline headline-medium">Intent Tags</p>

    <div class="logo-combo-box">
      <img src="../assets/logo-icon.png" alt="Uniform" width="35" />
      <div class="combo-box" @click="toggleDropdown">
        <div class="dropdown-selected" :aria-expanded="dropdownShown">
          <div class="dropdown-selected__pane">
            <div class="dropdown-selected__text">Select an Intent Tag</div>
            <i
              aria-hidden="true"
              class="dropdown-selected__item-icon icon-chevron-down"
              :style="{
                transform: `rotate(${dropdownShown ? '180deg' : '360deg'})`,
              }"
            ></i>
          </div>
        </div>
      </div>
    </div>
    <div class="dropdown-options" v-show="dropdownShown">
      <div class="dropdown-options__pane">
        <div class="dropdown-options-group">
          <div class="dropdown-options-title">Intent Tags</div>
          <div class="dropdown-option switch-icon-select" v-for="intent in dropdownIntents" :key="intent.id">
            <a class="dropdown-option__pane" href="#" @click.prevent="addIntent(intent.id)">
              <div class="dropdown-option__name">{{ intent.name }}</div>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      dropdownShown: false,
    };
  },
  computed: {
    ...mapGetters({
      dropdownIntents: 'getDropdownIntents',
    }),
  },
  methods: {
    toggleDropdown() {
      this.dropdownShown = !this.dropdownShown;
      this.$emit('resize');
    },

    addIntent(id) {
      this.$store.commit('addIntent', id);

      this.$emit('resize');
      this.$emit('save');

      this.toggleDropdown();
    },
  },
};
</script>

<style scoped>
.headline {
  margin: 0 0 1rem 0;
}

.logo-combo-box {
  display: flex;
}

.logo-combo-box img {
  align-self: flex-start;
  margin: 0 0.7rem 0 0;
}

.dropdown-options__pane {
  max-height: initial;
}

.combo-box {
  width: 300px;
  margin: 0 0 2rem 0;
}

.dropdown-options {
  width: 300px;
  margin-top: 10px;
  position: relative;
  top: -2rem;
  left: 45px;
}

.multi-select__option {
  margin: 3px 1px 1px 0;
}
</style>
